import * as React from 'react'
import Label from '../components/label'
import { css } from '@emotion/react'
import { StaticImage } from 'gatsby-plugin-image'

const Creator = () => {
  return (
    <section css={sectionStyle}>
      <div css={sectionInnerStyle}>
        <Label labelTitle={'POP-UP Creator'} />
        <p css={textStyle}>POP-UP 3Dで展示会を開いたクリエイターを紹介！</p>
        <ul css={listStyle}>
          <li css={listBlockStyle}>
            <div css={listImageStyle}>
              <StaticImage src="../assets/images/creator03.png" alt="佐野藍" />
            </div>
            <div css={listContentsStyle}>
              <div css={listCatStyle}>Creator</div>
              <h3 css={listNameStyle}>佐野藍</h3>
              <div css={listTextStyle}>
                主に大理石を用いてドラゴンなどの幻獣や、ボールパイソンの連作「Python Series」を発表。
                <br />
                イメージの世界を大理石という強い素材で具現化する事を主なテーマとして、少しずつ世界を広げている。
              </div>
            </div>
            <div css={listButtonStyle}>
              <div css={buttonStyle}>
                <a href="https://make.dmm.com/shop/285015/" target="_blank" rel="noopener noreferrer">
                  <span>SHOP</span>
                </a>
              </div>
            </div>
          </li>
          <li css={listBlockStyle}>
            <div css={listImageStyle}>
              <StaticImage src="../assets/images/creator02.png" alt="吉田孝弥" />
            </div>
            <div css={listContentsStyle}>
              <div css={listCatStyle}>Creator</div>
              <h3 css={listNameStyle}>吉田孝弥</h3>
              <div css={listTextStyle}>
                蛍光色での配色を特徴とした彫刻作品を制作。
                <br />
                「誰でも強く!!!首太く!!!」をモットーに劇画似顔絵でも活躍中。
              </div>
            </div>
            <div css={listButtonStyle}>
              <div css={buttonStyle}>
                <a href="https://make.dmm.com/shop/282350/" target="_blank" rel="noopener noreferrer">
                  <span>SHOP</span>
                </a>
              </div>
            </div>
          </li>
          <li css={listBlockStyle}>
            <div css={listImageStyle}>
              <StaticImage src="../assets/images/creator01.png" alt="萩原亮" />
            </div>
            <div css={listContentsStyle}>
              <div css={listCatStyle}>Creator</div>
              <h3 css={listNameStyle}>萩原亮</h3>
              <div css={listTextStyle}>
                彫刻家、3DCGをモチーフとして活用し金属を主とした彫刻作品を制作。新しい彫刻の在り方、価値観を模索している。
              </div>
            </div>
            <div css={listButtonStyle}>
              <div css={buttonStyle}>
                <a href="https://make.dmm.com/shop/268679/" target="_blank" rel="noopener noreferrer">
                  <span>SHOP</span>
                </a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </section>
  )
}

const sectionStyle = css`
  width: 100%;
  margin-top: 120px;
  @media (max-width: 768px) {
    margin-top: 44px;
  }
`
const sectionInnerStyle = css`
  width: 1024px;
  margin: 0 auto;
  @media (max-width: 1023px) {
    width: 100%;
    padding: 0 24px;
  }
  @media (max-width: 768px) {
    width: 100%;
    padding: 0 16px;
  }
`
const textStyle = css`
  padding-top: 44px;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 1.8;
  @media (max-width: 768px) {
    padding-top: 24px;
  }
`
const listStyle = css`
  display: flex;
  padding-top: 40px;
  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`
const listBlockStyle = css`
  width: calc((100% - 144px) / 4);
  margin-right: 48px;
  &:last-child {
    margin-right: 0;
  }
  @media (max-width: 768px) {
    width: calc(50% - 15px);
    margin-right: 0px;
    margin-bottom: 32px;
    &:nth-of-type(odd) {
      margin-right: 15px;
    }
    &:nth-of-type(even) {
      margin-left: 15px;
    }
  }
`
const listImageStyle = css`
  width: 100%;
`
const listContentsStyle = css`
  padding: 16px;
  background-color: #ebeef2;
`
const listCatStyle = css`
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1;
  color: #999;
`
const listNameStyle = css`
  padding-top: 4px;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.5;
`
const listTextStyle = css`
  padding: 8px 0 24px;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 1.5;
`
const listButtonStyle = css`
  display: flex;
  justify-content: center;
  margin-top: -21px;
`
const buttonStyle = css`
  display: flex;
  width: 140px;
  height: 42px;
  background-color: transparent;
  border: 1px solid#f4989c;
  transition: 0.5s all;
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 140px;
    &::after {
      content: '';
      width: 10px;
      height: 10px;
      margin: 1px 0 0 6px;
      border: 0px;
      border-top: solid 2px #f4989c;
      border-right: solid 2px #f4989c;
      transform: rotate(45deg);
    }
    span {
      font-size: 1.6rem;
      font-weight: 400;
      line-height: 1;
      color: #f4989c;
    }
  }
  a:hover {
    background-color: #f4989c;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.3);
    transition: 0.5s;
    &::after {
      border-top: solid 2px #fff;
      border-right: solid 2px #fff;
    }
    span {
      color: #fff;
    }
  }
`

export default Creator
